import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule, ModalController } from '@ionic/angular';
import { IBrewfather } from 'app/models/brewfather';
import { BrewfatherExternalService } from 'app/services/external/brewfather.service';
import { ToastService } from 'app/services/toast.service';

/**
 * Modal that lists Brewfather batches (filtered by status, default Fermenting)
 * so a fermenter can be linked to one. Dismisses with `{ batch }`.
 */
@Component({
  selector: 'app-fermenter-batch-picker',
  templateUrl: './batch-picker.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, IonicModule],
})
export class BatchPickerComponent implements OnInit {

  @Input() brewfather!: IBrewfather;

  statuses = ['Planning', 'Brewing', 'Fermenting', 'Conditioning', 'Completed', 'Archived'];
  batchStatus = signal('Fermenting');
  items = signal<any[]>([]);
  loading = signal(false);

  constructor(
    private modalController: ModalController,
    private brewfatherExternalService: BrewfatherExternalService,
    private toastService: ToastService,
  ) { }

  ngOnInit() {
    this.setStatus(this.batchStatus());
  }

  setStatus(status: string) {
    this.batchStatus.set(status);
    this.items.set([]);
    this.fetch('');
  }

  displayName(item: any): string {
    return item.name === 'Batch' && item.recipe?.name ? item.recipe.name : item.name;
  }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async select(batch: any) {
    await this.modalController.dismiss({ batch });
  }

  /** Pages through all batches for the active status (same walk as search-brewfather). */
  private fetch(offset: string) {
    this.loading.set(true);
    this.brewfatherExternalService.getBatchesPaged(this.brewfather, offset, 10, this.batchStatus()).then((result) => {
      try {
        const batch = JSON.parse(result.data) as any[];
        const merged = [...this.items()];
        batch.forEach(element => {
          if (!merged.find(x => x._id === element._id)) {
            merged.push(element);
          }
        });
        this.items.set(merged);
        if (batch.length > 0) {
          this.fetch(batch[batch.length - 1]._id);
        } else {
          this.loading.set(false);
        }
      } catch {
        this.loading.set(false);
        this.toastService.error('Unable to get batches, check settings for Brewfather and try again.');
      }
    });
  }
}
